import { Navigate, Route, Routes } from 'react-router-dom'
import { LoginForm } from '@/components/auth/LoginForm'
import { SignUpForm } from '@/components/auth/SignUpForm'
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm'
import { UpdatePasswordForm } from '@/components/auth/UpdatePasswordForm'
import { AuthCallback } from './auth/callback'
import { AuthError } from './auth/error'
import { useAuth } from '@/contexts/AuthContext'

export function AuthRoutes() {
  const { user, loading } = useAuth()

  // Rediriger vers la page d'accueil si l'utilisateur est déjà connecté
  // sauf pour les pages de callback, d'erreur et de mise à jour du mot de passe
  if (user && !loading && !window.location.pathname.match(/\/(callback|error|update-password)$/)) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-screen w-full">
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="/signup" element={<SignUpForm />} />
        <Route path="/forgot-password" element={<ForgotPasswordForm />} />
        <Route path="/update-password" element={<UpdatePasswordForm />} />
        <Route path="/callback" element={<AuthCallback />} />
        <Route path="/error" element={<AuthError />} />
        <Route
          path="/verify-email"
          element={
            <div className="text-center">
              <h1 className="text-2xl font-bold mb-4">Vérifiez votre email</h1>
              <p className="text-muted-foreground">
                Un lien de confirmation a été envoyé à votre adresse email.
                <br />
                Veuillez cliquer sur ce lien pour activer votre compte.
              </p>
            </div>
          }
        />
      </Routes>
    </div>
  )
} 